import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { catchError, concatMap, debounceTime, distinctUntilChanged, finalize, from, map, of, Subscription, switchMap, take, toArray } from 'rxjs';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';
import { LoadingService } from '../../loading/loading.service';
import { AlertComponent } from '../../alert/alert.component';
import { ModalComponent } from '../../modal/modal.component';
import { DocumentosService } from 'src/app/modules/services/documentos/documentos.service';
import { TableDefaultService } from 'src/app/modules/shared/table-default/table-default.service';

@Component({
  selector: 'app-form-projetos',
  templateUrl: './form-projetos.component.html',
  styleUrls: ['./form-projetos.component.scss']
})
export class FormProjetosComponent implements OnInit {
  @Input() isEditMode = false;
  
  labelFirstButton = 'Salvar e continuar';
  labelSecondButton = '';
  idTipoProjeto = '';
  idProjeto = '';
  idDisciplinaVolume = '';
  idsArquivosRemovidos: string[] = [];

  form!: FormGroup;
  cnpj: any;
  disciplinaObject: any;
  disciplinaTempId = 0;

  firstStep = true;
  thirdStep = false;
  secondStepWithDisciplinas = false;
  secondStepWithoutDisciplinas = false;
  editing = false;
  editMode = false;

  origemObra = '';
  tipoObra = '';
  descricaoServico = '';
  validacaoProjetoExecutivo: any = null;

  searchControlContracts = new FormControl('', [Validators.required]);
  filteredOptionsContracts: any[] = [];
  selectedOptionContracts: any;
  optionsContratos: any[] = [];
  tiposProjetos: any[] = [];
  optionsParametrosServico: any[] = [];
  optionsDisciplinas: any[] = [];
  
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  disciplinasAdicionadas: any[] = [];
  subscriptions: Subscription[] = [];
  
  columnConfig = [
    { columnDef: 'volume', header: 'Disciplina', property: 'disciplina.volume.nome', customTd: true },
    { columnDef: 'acao', header: 'Ação', property: 'acao', customTd: true }
  ];
  
  private readonly VALID_EXTENSIONS = [
    'pdf', 'doc', 'docx', 'txt', 'odt', 'xlsx', 'xls', 'csv', 'ods', 
    'ppt', 'pptx', 'odp', 'jpeg', 'jpg', 'png', 'zip', 'rar', 'html', 'htm'
  ];
  
  filesAdded: any[] = [];
  filesAddedArt: any[] = [];
  imagens: any[] = [];
  arquivos: string[] = [];
  firstLine: any[] = [];
  secondtLine: any[] = [];
  documentsForView: any[] = [];
  imagensArt: any[] = [];
  arquivosArt: string[] = [];
  firstLineArt: any[] = [];
  secondtLineArt: any[] = [];
  documentsForViewArt: any[] = [];
  
  private imagePageIndex = 0;
  private imagePageIndexArt = 0;
  private documentPageIndex = 0;
  private documentPageIndexArt = 0;
  private readonly itemsPerPage = { img: 8, doc: 4 };
  projeto: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private contractService: ContractService,
    private projetosService: ProjetosService,
    public toastService: ToastService,
    private loadingService: LoadingService,
    private formatUtilsService: FormatUtilsService,
    private documentService: DocumentosService,
    private tableDefaultService: TableDefaultService,
    private route: ActivatedRoute
  ) {
    this.form = this.fb.group({
      idContrato: ['', Validators.required],
      idParametroServicoAmpliacao: ['', Validators.required],
      idTipoProjeto: ['', Validators.required],
      observacao: [''],
      idDisciplina: [''],
      volumeProjeto: ['']
    });

    this.setupSearchSubscriptions();
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.idProjeto = id;
        this.loadProjetoParaEdicao(id);
      }
    });
  }

  loadProjetoParaEdicao(id: string): void {
    this.loadingService.showLoading();
    this.projetosService.getProjetoEdicao(id).pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: (projeto: any) => {
        if (projeto.contrato?.id) {
          this.getParametrosServicos(projeto.contrato.id);
        } 
        this.projeto = projeto;
        this.cnpj = projeto.contrato?.company?.cnpj;

        this.form.patchValue({
          idContrato: projeto.contrato?.id,
          idParametroServicoAmpliacao: projeto.parametroServicoAmpliacao?.id,
          idTipoProjeto: projeto.tipoProjeto?.id,
          observacao: projeto.observacao
        });

        this.form.controls['idTipoProjeto'].disable();

        if (projeto.parametroServicoAmpliacao) {
          this.origemObra = projeto.parametroServicoAmpliacao.origemObra?.nome || '';
          this.tipoObra = projeto.parametroServicoAmpliacao.tipoObra?.nome || '';
          this.descricaoServico = projeto.parametroServicoAmpliacao.descricaoServico || '';
        }

        if (projeto.contrato?.id && projeto.parametroServicoAmpliacao?.id) {
          this.projetosService.getParametroServicoAmpliacao(projeto.contrato.id, projeto.parametroServicoAmpliacao.id)
            .pipe(take(1))
            .subscribe({
              next: (res: any) => {
                this.validacaoProjetoExecutivo = res.validacaoProjetoExecutivo ?? null;
                if (this.isExecutivoBlockedByValidation) {
                  this.toastService.showError(this.validacaoProjetoExecutivo.mensagem);
                }
              }
            });
        }

        if (projeto.arquivos?.length) {
          this.populateFormAndArquivos(projeto);
        }
      },
      error: err => this.handleRequestError(err)
    });
  }

  public get hasDisciplines(): boolean {
    return this.tiposProjetos.find(p => p.id === this.idTipoProjeto)?.nome === 'Executivo';
  }

  get isExecutivoBlockedByValidation(): boolean {
    const idTipo = this.form.getRawValue().idTipoProjeto;
    const tipoProjeto = this.tiposProjetos.find(p => p.id === idTipo);
    return tipoProjeto?.nome === 'Executivo' && this.validacaoProjetoExecutivo?.permitido === false;
  }

  isValidObra(): void {
    if (!this.form.controls['idContrato'].value) {
      this.toastService.showError('Selecione um contrato para continuar');
    }
  }

  selectVolume(event: any) {
    const disciplina = this.optionsDisciplinas.find(item => item.id == event.value);
    if (disciplina?.volume) {
      this.form.patchValue({ volumeProjeto: disciplina.volume.nome });
    }
  }

  onSubmit(action: string): void {
    this.idTipoProjeto = this.form.getRawValue().idTipoProjeto || this.idTipoProjeto;

    if (this.firstStep || (!this.firstStep && !this.thirdStep)) {
      return this.goToNextStep();
    }

    if (this.isEditMode) {
      this.updateProjectAndHandleResponse(action);
    } else {
      this.createProjectAndHandleResponse(action);
    }
  }

  private createProjectAndHandleResponse(action: string): void {
    if (!this.hasDisciplines && !this.filesAdded.length) {
      return this.toastService.showError('Adicione ao menos um arquivo para continuar');
    }

    if (!this.filesAddedArt.length) {
      return this.toastService.showError('Campo anexos ART é obrigatorio e deve conter ao menos um arquivo.');
    }

    const mapFiles = (files: any[]) => files.map(f => ({
      nomeArquivo: f.nomeArquivo,
      tipoMime: f.tipoMime,
      categoria: f.categoria,
      subCategoria: f.subCategoria
    }));

    const data = {
      ...this.form.value,
      arquivos: this.hasDisciplines ? [] : mapFiles(this.filesAdded),
      arquivosART: mapFiles(this.filesAddedArt)
    };

    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(data)], { type: 'application/json' }));

    if (!this.hasDisciplines) {
      this.filesAdded.forEach(f => {
        if (f.objetoOriginal) {
          formData.append('arquivosComprovacao', f.objetoOriginal, f.nomeArquivo);
        }
      });
    }

    this.filesAddedArt.forEach(f => {
      if (f.objetoOriginal) {
        formData.append('arquivosArt', f.objetoOriginal, f.nomeArquivo);
      }
    });

    this.loadingService.showLoading();
    this.projetosService.createProjeto(formData).pipe(
      take(1),
      switchMap((res: any) => {
        this.idProjeto = res.id;

        if (!this.hasDisciplines || !this.disciplinasAdicionadas.length) {
          return of(res);
        }

        return from(this.disciplinasAdicionadas).pipe(
          concatMap((disc: any) => {
            const discData = {
              idDisciplina: disc.disciplina.id,
              arquivos: mapFiles(disc.arquivos)
            };
            const dfd = new FormData();
            dfd.append('request', new Blob([JSON.stringify(discData)], { type: 'application/json' }));
            
            disc.arquivos.forEach((f: any) => {
              if (f.objetoOriginal) {
                dfd.append('arquivosComprovacao', f.objetoOriginal, f.nomeArquivo);
              }
            });
            return this.projetosService.createDisciplinaVolume(res.id, dfd);
          }),
          toArray(),
          map(() => res)
        );
      }),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: () => {
        this.toastService.showSuccess('Projeto criado com sucesso');
        this.handleActionAfterSuccess(action);
      },
      error: err => this.handleRequestError(err)
    });
  }

  private updateProjectAndHandleResponse(action: string): void {
    const fv = this.form.getRawValue();

    const mapNew = (f: any, anexo: string) => ({
      nomeArquivo: f.nomeArquivo,
      tipoMime: f.tipoMime,
      categoria: f.categoria || 'cadastro_contrato',
      subCategoria: this.projeto.contrato.company.cnpj,
      tipoAnexo: anexo
    });

    const requestData = {
      idContrato: fv.idContrato,
      idParametroServicoAmpliacao: fv.idParametroServicoAmpliacao,
      observacao: fv.observacao,
      idsArquivosRemovidos: this.idsArquivosRemovidos,
      arquivosAdicionados: [
        ...this.filesAdded.filter(f => !f.id).map(f => mapNew(f, 'GERAL')),
        ...this.filesAddedArt.filter(f => !f.id).map(f => mapNew(f, 'ART'))
      ]
    };

    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(requestData)], { type: 'application/json' }));

    const todosArquivos = [...this.filesAdded, ...this.filesAddedArt];
    todosArquivos.filter(f => !f.id && f.objetoOriginal).forEach(f => {
      formData.append('arquivos', f.objetoOriginal, f.nomeArquivo);
    });

    this.loadingService.showLoading();
    this.projetosService.updateProjeto(this.idProjeto, formData).pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: () => {
        this.toastService.showSuccess('Projeto editado com sucesso');
        this.handleActionAfterSuccess(action);
      },
      error: err => this.handleRequestError(err)
    });
  }

  async editProjectAndHandleResponse() {
    const formData = new FormData();
    const data = {
      idDisciplina: this.form.value.idDisciplina,
      arquivos: this.filesAdded.map(f => ({
        nomeArquivo: f.nomeArquivo,
        tipoMime: f.tipoMime,
        categoria: f.categoria,
        subCategoria: f.subCategoria
      }))
    };

    formData.append('request', new Blob([JSON.stringify(data)], { type: 'application/json' }));

    this.filesAdded.forEach(f => {
      if (f.objetoOriginal) {
        const fileToAppend = f.recovered ? new File([], '') : f.objetoOriginal;
        const fileName = f.recovered ? undefined : f.nomeArquivo;
        formData.append('arquivosComprovacao', fileToAppend, fileName);
      }
    });

    this.loadingService.showLoading();
    console.log(this.idDisciplinaVolume)
    this.projetosService.editarDisciplina(this.idProjeto, this.idDisciplinaVolume, formData).pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: () => {
        this.reiniciar();
        this.resetFormState(false);
        this.editMode = false;
        this.getListDisciplinas();
        this.tableDefaultService.enviarStatus(true);
        this.toastService.showSuccess('Projeto atualizado com sucesso');
      },
      error: err => this.handleRequestError(err)
    });
  }

  private handleActionAfterSuccess(action: string): void {
    if (action === 'cad_and_close') {
      this.router.navigate([`projetos`]);
    } else {
      this.cadastrarNovo();
    }
  }

  editar(id: any) {
    this.editMode = true;
    this.idDisciplinaVolume = id;
    this.getDisciplinaPorId(id);
  }

  getDisciplinaPorId(id: any) {
    if (!this.idProjeto) {
      const disc = this.disciplinasAdicionadas.find(item => item.id == id);
      if (!disc) {
        return this.toastService.showError('Erro ao buscar tipos de projetos.');
      }

      this.disciplinaObject = disc;
      this.imagens = [];
      this.arquivos = [];
      this.filesAdded = disc.arquivos.map((a: any) => ({ ...a }));

      disc.arquivos.forEach((a: any) => {
        const extensao = a.nomeArquivo.split('.').pop()?.toLowerCase() || '';
        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(extensao);
        
        if (isImage) {
          this.imagens.push({ fileUrl: URL.createObjectURL(a.objetoOriginal), fileName: a.nomeArquivo });
          this.organizeImages();
        } else {
          this.arquivos.push(a.nomeArquivo);
          this.organizeDocuments();
        }
      });

      this.form.patchValue({
        idDisciplina: disc.disciplina.id,
        volumeProjeto: disc.disciplina.volume?.nome || ''
      });
      return;
    }

    this.projetosService.getDisciplinaPorId(this.idProjeto, id).pipe(take(1)).subscribe({
      next: (res: any) => {
        this.disciplinaObject = res;
        this.populateFormAndArquivos(res);
      },
      error: () => this.toastService.showError('Erro ao buscar tipos de projetos.')
    });
  }

  async populateFormAndArquivos(result: any) {
    const arquivosRecebidos = Array.isArray(result) ? result : result.arquivos || [];
    
    this.reiniciar();
    this.reiniciarArt();

    for (const arquivo of arquivosRecebidos) {
      const extensao = arquivo.nomeArquivo.split('.').pop()?.toLowerCase() || '';
      const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'].includes(extensao);
      
      if (!this.isEditMode) {
         this.getSelectedDocumento(arquivo.id, arquivo);
      } else {

        const cnpjSemFormatacao = this.projeto?.contrato?.company?.cnpj || '';
        const fileObj = {
          id: arquivo.id,
          nomeArquivo: arquivo.nomeArquivo,
          tipoMime: extensao,
          categoria: 'cadastro_contrato',
          subCategoria: cnpjSemFormatacao,
          objetoOriginal: null,
          recovered: true
        };

        if (arquivo.tipoAnexo === 'ART') {
          this.filesAddedArt.push(fileObj);
        } else {
          this.filesAdded.push(fileObj);
        }
      }
      
      if (arquivo.tipoAnexo === 'ART') {
        if (isImage) {
          this.imagensArt.push({ fileUrl: arquivo.sasURL, fileName: arquivo.nomeArquivo });
          this.organizeImagesArt();
        } else {
          this.arquivosArt.push(arquivo.nomeArquivo);
          this.organizeDocumentsArt();
        }
      } else {
        if (isImage) {
          this.imagens.push({ fileUrl: arquivo.sasURL, fileName: arquivo.nomeArquivo });
          this.organizeImages();
        } else {
          this.arquivos.push(arquivo.nomeArquivo);
          this.organizeDocuments();
        }
      }
    }
    this.form.controls['idDisciplina'].patchValue(result.disciplina?.id);
  }

  private async fetchBlobFromUrl(url: string, nomeArquivo: string): Promise<File | null> {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error();
      const blob = await response.blob();
      return new File([blob], nomeArquivo, { type: blob.type });
    } catch {
      return null;
    }
  }

  getSelectedDocumento(id: string, arquivo: any) {
    this.loadingService.showLoading();
    
    this.subscriptions.push(this.documentService.downloadFormProjeto(this.idProjeto, this.disciplinaObject?.id || '', arquivo.id).pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe(
      (res: any) => {
        const file = this.documentService.convertBlobToFile(res);
        const fileName = arquivo.nomeArquivo || 'default-name';
        const extensao = fileName.split('.').pop()?.toLowerCase() || '';
        const cnpjSemFormatacao = this.formatUtilsService.formatCnpj(this.cnpj)?.replace(/\D/g, '') || '';
        const selectedFile = file ? new File([file], fileName, { type: file.type }) : file;

        const fileObj = {
          id: arquivo.id,
          nomeArquivo: fileName,
          tipoMime: extensao,
          categoria: 'cadastro_contrato',
          subCategoria: cnpjSemFormatacao,
          objetoOriginal: selectedFile,
          recovered: true
        };

        if (arquivo.tipoAnexo === 'ART') {
          this.filesAddedArt.push(fileObj);
        } else {
          this.filesAdded.push(fileObj);
        }
      },
      err => {
        if (err.status !== 500 && err.status) {
          this.toastService.showError(err.error.message);
        }
      }
    ));
  }

  desvincular(id: any) {
    this.dialog.open(ModalComponent, {
      data: {
        onPerformAction: this.onDeleteModalConfirm.bind(this),
        modalTitle: 'Desvincular',
        modalContent: 'Você tem certeza que deseja desvincular esta disciplina?',
        id
      }
    });
  }

  onDeleteModalConfirm(id: any): void {
    const success = () => {
      this.openSnackBar('Disciplina desvinculada com sucesso!', 'sucess');
      this.getListDisciplinas();
      this.resetFormState(false);
      this.reiniciar();
      this.editMode = false;
    };

    if (!this.idProjeto) {
      this.disciplinasAdicionadas = this.disciplinasAdicionadas.filter(item => item.id != id);
      success();
      return;
    }

    this.projetosService.desvincularDisciplina(this.idProjeto, id).pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: success,
      error: err => this.handleRequestError(err)
    });
  }

  back(): void {
    this.router.navigate(['/projetos']);
  }

  goToPreviousStep(): void {
    if (this.thirdStep) {
      this.thirdStep = false;
      this.labelFirstButton = 'Salvar e continuar';
      this.labelSecondButton = '';
    } else if (!this.firstStep) {
      this.firstStep = true;
      this.labelFirstButton = 'Salvar e continuar';
      this.labelSecondButton = '';
    }
  }

  goToNextStep(): void {
    if (this.firstStep && this.isExecutivoBlockedByValidation) {
      this.toastService.showError(this.validacaoProjetoExecutivo.mensagem);
      return;
    }

    if (this.firstStep && this.form.valid) {
      this.firstStep = false;
      this.labelFirstButton = 'Salvar e continuar';
      this.labelSecondButton = '';
      if (this.hasDisciplines) {
        this.getDisciplinas();
        this.getListDisciplinas();
      }
      return;
    }

    if (!this.firstStep && !this.thirdStep) {
      this.thirdStep = true;
      this.labelFirstButton = 'Salvar e finalizar';
      this.labelSecondButton = 'Salvar e cadastrar novo';
    }
  }

  onAddDiscipline(): void {
    const disc = this.optionsDisciplinas.find(item => item.id == this.form.value.idDisciplina);
    
    if (!disc) {
      return this.toastService.showError('Selecione uma disciplina para continuar');
    }

    if (!this.idProjeto) {
      const arquivos = this.filesAdded.map(f => ({ ...f }));
      
      if (!this.editMode) {
        this.disciplinasAdicionadas.push({ id: `temp-${++this.disciplinaTempId}`, disciplina: disc, arquivos });
        this.toastService.showSuccess('Disciplina criada com sucesso');
      } else {
        this.disciplinasAdicionadas = this.disciplinasAdicionadas.map(item => 
          item.id != this.idDisciplinaVolume ? item : { ...item, disciplina: disc, arquivos }
        );
        this.toastService.showSuccess('Projeto editado com sucesso');
      }

      this.resetFormState(false);
      this.reiniciar();
      this.getListDisciplinas();
      this.editMode = false;
      return;
    }

    if (!this.editMode) {
      const data = {
        idDisciplina: disc.id,
        arquivos: this.filesAdded.map(f => ({
          nomeArquivo: f.nomeArquivo,
          tipoMime: f.tipoMime,
          categoria: f.categoria,
          subCategoria: f.subCategoria
        }))
      };

      const formData = new FormData();
      formData.append('request', new Blob([JSON.stringify(data)], { type: 'application/json' }));

      this.filesAdded.forEach(f => {
        if (f.objetoOriginal) {
          formData.append('arquivosComprovacao', f.objetoOriginal, f.nomeArquivo);
        }
      });

      this.projetosService.createDisciplinaVolume(this.idProjeto, formData).pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      ).subscribe({
        next: () => {
          this.toastService.showSuccess('Disciplina criada com sucesso');
          this.resetFormState(false);
          this.reiniciar();
          this.getListDisciplinas();
        },
        error: err => this.handleRequestError(err)
      });
    } else {
      this.editProjectAndHandleResponse();
    }
  }

  resetFormState(resetGeneral = true): void {
    const fv = this.form.getRawValue();
    this.form.reset({
      idContrato: resetGeneral ? '' : fv.idContrato,
      idParametroServicoAmpliacao: resetGeneral ? '' : fv.idParametroServicoAmpliacao,
      idTipoProjeto: resetGeneral ? '' : fv.idTipoProjeto,
      observacao: resetGeneral ? '' : fv.observacao,
      idDisciplina: '',
      volumeProjeto: ''
    });

    if (resetGeneral) {
      this.origemObra = '';
      this.tipoObra = '';
      this.descricaoServico = '';
      this.validacaoProjetoExecutivo = null;
    }

    Object.keys(this.form.controls).forEach(k => {
      this.form.get(k)?.markAsPristine();
      this.form.get(k)?.markAsUntouched();
      this.form.get(k)?.updateValueAndValidity();
    });
  }

  private setupSearchSubscriptions(): void {
    this.searchControlContracts.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(val => this.contractService.getContracts(0, 'asc', 'contractName', '', '', '', '', '', '', '', val?.trim()).pipe(
        catchError(() => of([]))
      ))
    ).subscribe((res: any) => {
      this.filteredOptionsContracts = res.content;
    });

    this.getTiposProjetos();
    this.getContratos();
  }

  onOptionSelectedContracts(event: any): void {
    this.form.controls['idParametroServicoAmpliacao'].setValue('');
    this.selectedOptionContracts = event.value;
    this.origemObra = '';
    this.tipoObra = '';
    this.descricaoServico = '';
    this.validacaoProjetoExecutivo = null;

    const dataObj = this.optionsContratos.find(e => e.id === event.value);
    if (dataObj) {
      this.cnpj = dataObj.company.cnpj;
    }

    this.getParametrosServicos(this.selectedOptionContracts);
  }

  onObraSelected(event: any): void {
    const idContrato = this.form.getRawValue().idContrato;
    const idParametroServicoAmpliacao = event.value;
    if (!idContrato || !idParametroServicoAmpliacao) return;

    this.projetosService.getParametroServicoAmpliacao(idContrato, idParametroServicoAmpliacao)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.origemObra = res.origemObra?.nome || '';
          this.tipoObra = res.tipoObra?.nome || '';
          this.descricaoServico = res.descricaoServico || '';
          this.validacaoProjetoExecutivo = res.validacaoProjetoExecutivo ?? null;
        },
        error: () => this.toastService.showError('Erro ao buscar dados da obra.')
      });
  }

  getTiposProjetos(): void {
    this.projetosService.getTiposProjetos().pipe(take(1)).subscribe({
      next: (res: any) => this.tiposProjetos = res?.content ?? [],
      error: () => this.toastService.showError('Erro ao buscar tipos de projetos.')
    });
  }

  getContratos(): void {
    this.projetosService.getContratos().pipe(take(1)).subscribe({
      next: (res: any) => this.optionsContratos = res?.content ?? [],
      error: () => this.toastService.showError('Erro ao buscar contratos.')
    });
  }

  getParametrosServicos(id: any): void {
    this.projetosService.getParametrosServicos(id).pipe(take(1)).subscribe({
      next: (res: any) => this.optionsParametrosServico = res?.content ?? [],
      error: () => this.toastService.showError('Erro ao buscar parâmetros.')
    });
  }

  getDisciplinas(): void {
    this.loadingService.showLoading();
    this.projetosService.getDisciplinas().pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: (res: any) => {
        this.optionsDisciplinas = res.content;
      },
      error: err => this.handleRequestError(err)
    });
  }

  getListDisciplinas() {
    if (!this.idProjeto) {
      this.dataSource.data = this.disciplinasAdicionadas;
      return;
    }

    this.projetosService.getDisciplinasCadastradasPorId(this.idProjeto).pipe(
      take(1),
      finalize(() => this.loadingService.hideLoading())
    ).subscribe({
      next: (res: any) => {
        this.dataSource.data = res.content;
      },
      error: err => this.handleRequestError(err)
    });
  }

  private handleFileUpload(event: Event, isArt: boolean): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    Array.from(input.files).forEach(file => {
      const ext = file.name.split('.').pop()?.toLowerCase() || '';
      
      if (!this.VALID_EXTENSIONS.includes(ext)) {
        return this.toastService.showError(`Formato inválido: ${this.VALID_EXTENSIONS.join(' | ').toUpperCase()}`);
      }

      const reader = new FileReader();
      reader.onload = () => {
        const isImage = file.type.startsWith('image');
        const cnpjLimpo = this.formatUtilsService.formatCnpj(this.cnpj)?.replace(/\D/g, '') || '';
        
        const fileObj = {
          nomeArquivo: file.name,
          tipoMime: ext,
          categoria: 'cadastro_contrato',
          subCategoria: cnpjLimpo,
          objetoOriginal: file
        };

        if (isArt) {
          if (isImage) {
            this.imagensArt.push({ fileUrl: reader.result, fileName: file.name });
            this.organizeImagesArt();
          } else {
            this.arquivosArt.push(file.name);
            this.organizeDocumentsArt();
          }
          this.filesAddedArt.push(fileObj);
        } else {
          if (isImage) {
            this.imagens.push({ fileUrl: reader.result, fileName: file.name });
            this.organizeImages();
          } else {
            this.arquivos.push(file.name);
            this.organizeDocuments();
          }
          this.filesAdded.push(fileObj);
        }
      };
      reader.readAsDataURL(file);
    });

    input.value = '';
  }

  onFileSelected(event: Event): void {
    this.handleFileUpload(event, false);
  }

  onFileSelectedArt(event: Event): void {
    this.handleFileUpload(event, true);
  }

  private slicePage(arr: any[], page: number, perPage: number) {
    return arr.slice(page * perPage, (page + 1) * perPage);
  }

  private organizeImages(): void {
    this.imagePageIndex = 0;
    this.updateImageLines();
  }

  private updateImageLines(): void {
    const p = this.slicePage(this.imagens, this.imagePageIndex, this.itemsPerPage.img);
    this.firstLine = p.slice(0, 4);
    this.secondtLine = p.slice(4, 8);
  }

  prevImages(): void {
    if (this.imagePageIndex > 0) {
      this.imagePageIndex--;
      this.updateImageLines();
    }
  }

  nextImages(): void {
    if (this.imagePageIndex < Math.ceil(this.imagens.length / this.itemsPerPage.img) - 1) {
      this.imagePageIndex++;
      this.updateImageLines();
    }
  }

  private organizeDocuments(): void {
    this.documentPageIndex = 0;
    this.updateDocumentView();
  }

  private updateDocumentView(): void {
    this.documentsForView = this.slicePage(this.arquivos, this.documentPageIndex, this.itemsPerPage.doc);
  }

  prevDocuments(): void {
    if (this.documentPageIndex > 0) {
      this.documentPageIndex--;
      this.updateDocumentView();
    }
  }

  nextDocuments(): void {
    if (this.documentPageIndex < Math.ceil(this.arquivos.length / this.itemsPerPage.doc) - 1) {
      this.documentPageIndex++;
      this.updateDocumentView();
    }
  }

  private organizeImagesArt(): void {
    this.imagePageIndexArt = 0;
    this.updateImageLinesArt();
  }

  private updateImageLinesArt(): void {
    const p = this.slicePage(this.imagensArt, this.imagePageIndexArt, this.itemsPerPage.img);
    this.firstLineArt = p.slice(0, 4);
    this.secondtLineArt = p.slice(4, 8);
  }

  prevImagesArt(): void {
    if (this.imagePageIndexArt > 0) {
      this.imagePageIndexArt--;
      this.updateImageLinesArt();
    }
  }

  nextImagesArt(): void {
    if (this.imagePageIndexArt < Math.ceil(this.imagensArt.length / this.itemsPerPage.img) - 1) {
      this.imagePageIndexArt++;
      this.updateImageLinesArt();
    }
  }

  private organizeDocumentsArt(): void {
    this.documentPageIndexArt = 0;
    this.updateDocumentViewArt();
  }

  private updateDocumentViewArt(): void {
    this.documentsForViewArt = this.slicePage(this.arquivosArt, this.documentPageIndexArt, this.itemsPerPage.doc);
  }

  prevDocumentsArt(): void {
    if (this.documentPageIndexArt > 0) {
      this.documentPageIndexArt--;
      this.updateDocumentViewArt();
    }
  }

  nextDocumentsArt(): void {
    if (this.documentPageIndexArt < Math.ceil(this.arquivosArt.length / this.itemsPerPage.doc) - 1) {
      this.documentPageIndexArt++;
      this.updateDocumentViewArt();
    }
  }

  reiniciar(): void {
    this.imagens = [];
    this.arquivos = [];
    this.filesAdded = [];
    this.updateImageLines();
    this.updateDocumentView();
  }

  reiniciarArt(): void {
    this.imagensArt = [];
    this.arquivosArt = [];
    this.filesAddedArt = [];
    this.updateImageLinesArt();
    this.updateDocumentViewArt();
  }

  salvarEFechar() {
    this.toastService.showSuccess('Disciplinas criadas com sucesso');
    this.back();
  }

  private trackRemoved(list: any[], name: string) {
    const f = list.find(x => x.nomeArquivo === name);
    if (f?.id) {
      this.idsArquivosRemovidos.push(f.id);
    }
  }

  removeImg(img: any): void {
    this.trackRemoved(this.filesAdded, img.fileName);
    this.imagens = this.imagens.filter(p => p.fileName !== img.fileName);
    this.filesAdded = this.filesAdded.filter(a => a.nomeArquivo !== img.fileName);
    this.organizeImages();
  }

  removeFile(file: any): void {
    this.trackRemoved(this.filesAdded, file);
    this.arquivos = this.arquivos.filter(a => a !== file);
    this.filesAdded = this.filesAdded.filter(a => a.nomeArquivo !== file);
    this.organizeDocuments();
  }

  removeImgArt(img: any): void {
    this.trackRemoved(this.filesAddedArt, img.fileName);
    this.imagensArt = this.imagensArt.filter(p => p.fileName !== img.fileName);
    this.filesAddedArt = this.filesAddedArt.filter(a => a.nomeArquivo !== img.fileName);
    this.organizeImagesArt();
  }

  removeFileArt(file: any): void {
    this.trackRemoved(this.filesAddedArt, file);
    this.arquivosArt = this.arquivosArt.filter(a => a !== file);
    this.filesAddedArt = this.filesAddedArt.filter(a => a.nomeArquivo !== file);
    this.organizeDocumentsArt();
  }

  cadastrarNovo() {
    this.resetFormState();
    this.reiniciar();
    this.reiniciarArt();
    this.dataSource = new MatTableDataSource<any>([]);
    this.disciplinasAdicionadas = [];
    this.editMode = false;
    this.firstStep = true;
    this.thirdStep = false;
    this.idTipoProjeto = '';
    this.idProjeto = '';
    this.labelFirstButton = 'Salvar e continuar';
    this.labelSecondButton = '';
  }

  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error'
      );
    }
  }

  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error'
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
}